import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ScienceSection() {
  const sciencePoints = [{
    title: 'Increase Nitric Oxide Naturally',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hTGYCfoa48v9kcFz9gxZq7/9fc91bfe-f09c-4d29-8303-0da78fe5136a.gif',
    description: "Robert found legitimate Mayo Clinic research showing cayenne's active compound (capsaicin) can:",
    benefits: ['Dilate blood vessels by up to 23%', 'Improve blood flow to extremities', 'Support healthy blood pressure', 'Create warming sensation from within'],
    quote: "I couldn't believe no VA doctor ever mentioned this to me."
  }, {
    title: 'Reduce Hidden Inflammation in Arteries',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uK7AFb1NT1AqayzJJy1sgF/9a0e4de2-1e58-4af0-8b19-7a8ef7c2b679.gif',
    description: "Chronic inflammation stiffens your arteries and slows blood flow. Robert learned that turmeric's curcumin outperforms many prescription anti-inflammatories for:",
    benefits: ['Reducing arterial inflammation', 'Supporting flexible blood vessels', 'Improving circulation naturally'],
    quote: "The research was buried, but it's all there."
  }, {
    title: 'Strengthen Arterial Walls with D3 + K2',
    image: 'https://images.unsplash.com/photo-1571019613914-85f342c6a11e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    description: 'Most people are deficient in Vitamin K2 - the nutrient that:',
    benefits: ['Keeps calcium OUT of your arteries', 'Directs calcium TO your bones where it belongs', 'Works with D3 to support circulation', 'Maintains arterial flexibility'],
    quote: "My doctor never mentioned K2. Now I know why my calcium supplements weren't helping."
  }, {
    title: 'Target Blood Sugar Spikes That Disrupt Flow',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mACsdgg1KHNBNp8kfo5J3H/pasted-image.jpg',
    description: 'Hidden blood sugar spikes damage your circulation over time. Natural compounds like beetroot and hawthorn help:',
    benefits: ['Support healthy blood sugar already in normal range', 'Protect blood vessels from sugar damage', 'Improve nitric oxide production', 'Enhance overall circulation']
  }, {
    title: 'Backed by Science, Real Results',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/63BGoUEio1TXbLbuXwhnpX/Untitled_design_%2859%29.png',
    description: "Unlike Big Pharma's synthetic drugs, these ingredients have been studied extensively:",
    benefits: ['Mayo Clinic: Capsaicin improves circulation', 'Stanford University: Beetroot boosts blood flow', 'European Journal: Hawthorn supports heart health', 'University of Maryland: K2 protects arteries'],
    quote: "The research exists - they just don't want you to know about it."
  }];
  return <section className="py-8 md:py-12" data-id="element-147">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 md:mb-12" data-id="element-148">
        The Science Behind Better Circulation
      </h2>
      {sciencePoints.map((point, index) => <div key={index} className={`mb-8 md:mb-16 pb-8 md:pb-16 ${index !== sciencePoints.length - 1 ? 'border-b border-gray-200' : ''}`} data-id="element-149">
          <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 flex items-center" data-id="element-150">
            <span className="bg-red-600 text-white rounded-full w-7 h-7 md:w-8 md:h-8 flex items-center justify-center mr-2 md:mr-3 flex-shrink-0" data-id="element-151">
              {index + 1}
            </span>
            {point.title}
          </h3>
          <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-152">
            <div className="w-full md:w-1/2" data-id="element-153">
              <img src={point.image} alt={point.title} className="w-full h-auto rounded-lg shadow-lg" data-id="element-154" />
            </div>
            <div className="w-full md:w-1/2 mt-4 md:mt-0" data-id="element-155">
              <p className="text-base md:text-lg mb-3 md:mb-4" data-id="element-156">
                {point.description}
              </p>
              <ul className="mb-4 md:mb-6" data-id="element-157">
                {point.benefits.map((benefit, i) => <li key={i} className="flex items-start mb-2 md:mb-3" data-id="element-158">
                    <CheckIcon className="w-4 h-4 md:w-5 md:h-5 text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-159" />
                    <span className="text-sm md:text-base" data-id="element-160">{benefit}</span>
                  </li>)}
              </ul>
              {point.quote && <blockquote className="italic border-l-4 border-red-500 pl-3 md:pl-4 py-1 md:py-2 text-sm md:text-base text-gray-700" data-id="element-161">
                  "{point.quote}" — Robert
                </blockquote>}
            </div>
          </div>
          {index === 4 ? <div className="mt-6 md:mt-8 flex justify-center" data-id="element-162">
              <a href="https://tryvascura.com/products/cayenne-pepper-supplement-liquid-drops" className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 md:py-3 px-6 md:px-8 rounded-full shadow-lg transition duration-300 w-full md:w-auto text-sm md:text-base" data-id="element-163">
                Get 50% Off Vascura Drops →
              </a>
            </div> : null}
        </div>)}
    </section>;
}